import React, { Component } from 'react'
import { Button, Modal, Form, Radio } from 'semantic-ui-react'

export default class ModalVerify extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: null
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.reasonValue })
  }

  /* =========================================
  :: Handle Function
  ==========================================*/

  handleChange = (e, { value }) => {
    e.preventDefault();
    this.setState({ value: value });
  }

  handleButtonCancel = (e) => {
    e.preventDefault();
    this.setState({value: ''});
    this.props.reasonChangeValue('');
    this.props.onClose();
  }

  handleButtonTrue = (e) => {
    e.preventDefault();
    this.props.reasonChangeValue(this.state.value);
    this.props.onClose();
  }

  /* =========================================
  :: Render
  ==========================================*/

  render() {
    const { trigger, reasonsData, open, onClose } = this.props

    return (
      <Modal
        trigger={trigger}
        open={open}
        onClose={onClose}
      >
        <Modal.Header>Alasan ditolak</Modal.Header>
        <Modal.Content>
          <Form>
            {
              reasonsData ? reasonsData.map((reason, i) => {
                return (
                  <Form.Field key={i}>
                    <Radio
                      label={reason}
                      name='reasonGroup'
                      value={reason}
                      checked={reason === this.state.value}
                      onChange={this.handleChange}
                    />
                  </Form.Field>
                )
              }) : '<p>No option reason</p>'
            }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='red' onClick={this.handleButtonCancel}>Batal</Button>
          <Button color='green' onClick={this.handleButtonTrue}>Lanjut</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/component/Verification/ModalVerify.js